import { IUserInfo } from "@home-health-notify/domain";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "hhn-commons";
import { useState } from "react";
import theme from "../../../../../theme";

export const AboutPatient = ({ userInfo }: { userInfo: IUserInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "privateChatInfo" });
  const [showFullContent, setShowFullContent] = useState(false);
  const toggleShowFullContent = () => {
    setShowFullContent(!showFullContent);
  };
  const aboutText = userInfo?.about ? userInfo.about : "N/A";
  const displayText = showFullContent ? aboutText : aboutText.slice(0, 500);

  return (
    <Box sx={{ padding: "20px" }} data-testid="chat-info-about-section">
      <Typography sx={{ marginBottom: "5px" }}>{tNs("about")}</Typography>
      <Typography data-testid="about-user">
        {displayText}
        {aboutText.length > 500 && (
          <span
            style={{ color: theme.palette.primary.main, cursor: "pointer" }}
            onClick={toggleShowFullContent}
          >
            {showFullContent ? " " + tNs("seeLess") : tNs("seeMore")}
          </span>
        )}
      </Typography>
    </Box>
  );
};
